export var VELT_SDK_VERSION = '5.0.2-beta.4';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '5.0.2-beta.4': 'sha384-+43/FRK/cLNnNVE4RecynwhDmvj43/XHhGNI46A7fmJF7IPgJZ8kztGM1Q7HTTej',
};
